import { lazy, Suspense } from "react";
import LandingHeader from "../navigation/LandingHeader";
import { Outlet } from "react-router-dom";
import { Grid } from "@mui/material";
import { contentWithoutAuthStyle, headerContainerStyle } from "../SharedStyles";
import PageLoader from "../common/PageLoader";

const Footer = lazy(() => import("../footer/Footer"));

export const Layout = ({ showFooter }: { showFooter: boolean }) => (
    <Grid container>
        <Suspense fallback={<PageLoader height="100vh" />}>
            <Grid item xs={12} sx={headerContainerStyle}>
                <LandingHeader />
            </Grid>
            <Grid item xs={12} sx={contentWithoutAuthStyle}>
                <Outlet />
            </Grid>
            {showFooter && (
                <Grid item xs={12}>
                    <Footer />
                </Grid>
            )}
        </Suspense>
    </Grid>
);
